export default "__VITE_ASSET__47aDuMhc__"